import { render, staticRenderFns } from "./gyra-spinner.vue?vue&type=template&id=72a109ce&scoped=true&"
import script from "./gyra-spinner.vue?vue&type=script&lang=js&"
export * from "./gyra-spinner.vue?vue&type=script&lang=js&"
import style0 from "./gyra-spinner.vue?vue&type=style&index=0&id=72a109ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a109ce",
  null
  
)

export default component.exports